import React, {createContext, useReducer, useContext} from 'react'
import PropTypes from 'prop-types'

const initialState = {
    compareItems: [],
}

const compareActionTypes = {
    ADD_ITEM: 'ADD_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM',
    CLEAR_ITEMS: 'CLEAR_ITEMS',
}

const compareReducer = (state, action) => {
    switch (action.type) {
        case compareActionTypes.ADD_ITEM:
            return {
                ...state,
                compareItems: [...state.compareItems, action.payload],
            }
        case compareActionTypes.REMOVE_ITEM:
            return {
                ...state,
                compareItems: state.compareItems.filter(
                    (item) => item.productId !== action.payload.productId,
                ),
            }
        case compareActionTypes.CLEAR_ITEMS:
            return {
                ...state,
                compareItems: [],
            }
        default:
            return state
    }
}

export const CompareContext = createContext()

export const CompareProvider = ({children}) => {
    const [state, dispatch] = useReducer(compareReducer, initialState)

    const addItem = (item) => {
        dispatch({type: 'ADD_ITEM', payload: item})
    }

    const removeItem = (item) => {
        dispatch({type: 'REMOVE_ITEM', payload: item})
    }

    const clearItems = () => {
        dispatch({type: 'CLEAR_ITEMS'})
    }

    return (
        <CompareContext.Provider value={{state, addItem, removeItem, clearItems}}>
            {children}
        </CompareContext.Provider>
    )
}

CompareProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

export const useCompare = () => {
    return useContext(CompareContext)
}
